import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export const AdminRouter = () => {
  const { userRole } = useSelector((state) => state.auth);

  return userRole === "ADMIN" ? <Outlet /> : <Navigate to="/unauthorized" />;
};
